import styled from 'styled-components';

export const ModalStyle = styled.div`
  .modal-content {
    min-height: 111px;

    @media (max-width: 1090) {
      min-width: 60vw;
    }
  }

  .modal-body {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    padding: 40px;
    height: 100%;
    p {
      font-size: 14px;
    }
    img {
      width: 100%;
    }

    div {
      width: 100%;

      @media (max-width: 490px) {
        justify-content: start;
      }
    }

    @media (max-width: 978px) {
      flex-flow: wrap;
    }

    .firstColumn {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .mainDiv {
        width: 95%;
        height: 60px;
        border-radius: 3px;
        margin: 10px;
        background-color: #263340;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px;

        p {
          padding-top: 16px;
        }
      }

      .childrenDiv {
        display: flex;
        align-items: center;
        img {
          margin-right: 7px;
        }
      }
    }
    .secondColumn {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .mainDiv {
        width: 95%;
        height: 60px;
        border-radius: 3px;
        margin: 10px;
        background-color: #263340;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px;

        p {
          padding-top: 16px;
        }
      }

      .childrenDiv {
        display: flex;
        align-items: center;
        img {
          margin-right: 7px;
        }
      }
    }
  }
`;

export const Table = styled.div`
  .containerHeader {
    max-width: 1300px;
    width: 100%;
    display: flex;
    justify-content: center;

    @media (max-width: 1256px) {
      flex-flow: wrap;
      align-items: center;
      justify-content: center;
    }
  }

  overflow: auto;

  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  margin-bottom: 25px;

  table {
    width: 100%;
    border-radius: 7px;
    background-color: #32404e;

    td,
    th {
      border-top: 0;
      border-bottom: 0;
      text-align: center;
      width: 100px;

      display: flex;
      align-items: center;
      justify-content: center;

      img {
        padding-right: 4px;
        width: 20px;
        height: 20px;
      }
    }

    thead {
      display: flex;
      align-items: center;
      justify-content: center;
      tr {
        width: 98%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #6b8299;
        border-radius: 4px;
        height: 40px;
      }
    }
    tbody {
      display: flex;
      flex-direction: column;
      align-items: center;
      tr {
        width: 98%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 4px;
        height: 40px;

        div {
          display: flex;
          justify-content: center;
          p {
            padding-right: 3px;
            margin-bottom: 0;
          }
        }
        &:nth-child(2n + 1) {
          background-color: #263340;
        }
        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
`;
